// extracted by mini-css-extract-plugin
export default {"container":"style_container__bR2ES","main":"style_main__16eBd","infoCardWrapper":"style_infoCardWrapper__rncO2"};